import { render, staticRenderFns } from "./DetailField.vue?vue&type=template&id=fca715e0&scoped=true&"
import script from "./DetailField.vue?vue&type=script&lang=ts&"
export * from "./DetailField.vue?vue&type=script&lang=ts&"
import style0 from "./DetailField.vue?vue&type=style&index=0&id=fca715e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca715e0",
  null
  
)

export default component.exports